import React, { useState } from "react";
import "./Total.css";
import { TextField } from "@material-ui/core";
import Contacts from "./Contacts";

function Total(props: any) {
  const total_luvers_count =
    Number(props.konfigured["top_luvers_count"] || 0) +
    Number(props.konfigured["left_luvers_count"] || 0) +
    Number(props.konfigured["right_luvers_count"] || 0) +
    Number(props.konfigured["bottom_luvers_count"] || 0);

  return (
    <div className="total">
      <div className="total-title">Plandeka</div>
      <div className="total-item">
        <div className="total-subtitle">
          Obszar:{" "}
          <span className="totalValue">
            {" "}
            {props.konfigured["area"] / 10000} m<sup>2</sup>
          </span>
        </div>
        <div className="total-value">
          {props.price["material_price"] &&
            props.price["material_price"].toFixed(2)}{" "}
          PLN
        </div>
      </div>
      <div className="total-item">
        <div className="total-subtitle">
          Oczka: <span className="totalValue"> {total_luvers_count} </span>
        </div>
        <div className="total-value">
          {props.price["luvers_price"] &&
            props.price["luvers_price"].toFixed(2)}{" "}
          PLN
        </div>
      </div>
      <div className="total-item">
        <div className="total-subtitle">Ilość:</div>
        <div className="quatity-box">
          <button
            onClick={() => props.quantityHandle("-")}
            className="total-button-count"
          >
            -
          </button>
          <TextField
            id="standard-start-adornment"
            type="number"
            value={props.konfigured["quantity"]}
            name="quantity"
            onChange={(e) => props.onSelectChange(e)}
          />
          <button
            onClick={() => props.quantityHandle("+")}
            className="total-button-count"
          >
            +
          </button>
        </div>
      </div>
      <div className="total-item total-box">
        <span className="total-price">Ogólny:</span>
        <span className="total-value">
          {" "}
          {props.price["total"].toFixed(2)} PLN
        </span>
      </div>
      <div className="total-button">
        <Contacts
          text="Wyślij do produkcji"
          price={props.price}
          drawing={props.drawing}
          konfigured={props.konfigured}
        ></Contacts>
      </div>
    </div>
  );
}

export default Total;
